import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { ScheduledChainsTable } from "../components"

export const ScheduledChainsPage: FC = () => (
  <UserbotPage title="Расписания">
    <ScheduledChainsTable />
  </UserbotPage>
)
